export const DEAFULT_PROPS = {
  checkSelected: false,
  clearable: false,
  fluid: false,
  hasIcons: false,
  hideTextOnSelection: false,
  icon: 'dropdown',
  inline: false,
  isButton: false,
  isError: false,
  isLoading: false,
  noResultsMessage: 'No Results Found.',
  placeholder: '',
  search: false,
  searchCaseSensitive: false,
  simple: false,
  trigger: null,
  upward: false,
  closeOnChange: true,
};

export const DEFAULT_SELECTED_OPTION = { text: '', value: '' };
export const DROPDOWN_MENU_HEIGHT = 148;
export const DROPDOWN_ITEM_HEIGHT = 37;
export const OVERSCAN_COUNT = 3;
